import { createContext, useContext, useState, ReactNode } from 'react';

interface UIState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  /** simple toast queue */
  pushToast: (m: string) => void;
}

const UIContext = createContext<UIState | null>(null);

export const UIProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarOpen, setSidebar] = useState(true);
  const [toasts,       setToasts ] = useState<string[]>([]);

  const pushToast = (msg: string) => setToasts(t => [...t, msg]);

  return (
    <UIContext.Provider
      value={{
        sidebarOpen,
        toggleSidebar: () => setSidebar(o => !o),
        pushToast,
      }}
    >
      {children}

      {/* crude toast viewer; replace later */}
      <div style={{ position:'fixed', bottom:16, right:16 }}>
        {toasts.map((t, i) => (
          <div key={i} style={{ background:'#333', color:'#fff', padding:'8px 12px', marginTop:8, borderRadius:4 }}>
            {t}
          </div>
        ))}
      </div>
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error('useUI must be inside <UIProvider>');
  return ctx;
};
